module.exports = __webpack_public_path__ + "img/gbwatsapk-gbwhatsapp.9d9dab43.webp";